import React from 'react';
// components
import { Logo } from 'src/components/reusable/Logo';
import Container from 'src/components/reusable/Container';
import { UnstyledLink } from 'src/components/reusable/Links';
import { Button } from 'src/components/reusable/Buttons';
import { useAppDispatch } from 'src/store/hooks';
import {
  handleModal,
  handleModalLogin,
  handleModalRegister
} from 'src/store/actions/modal';

interface HeaderProps {}

const Header: React.FC<HeaderProps> = ({}) => {
  const dispatch = useAppDispatch();

  const handleOpenLogin = () => {
    dispatch(handleModal(true));
    dispatch(handleModalLogin(true));
  };

  const handleOpenRegister = () => {
    dispatch(handleModal(true));
    dispatch(handleModalRegister(true));
  };

  return (
    <header className="py-6 bg-white">
      <Container>
        <nav className="relative z-50 flex justify-between items-center">
          <div className="logo">
            <UnstyledLink href="/">
              <Logo className="w-24 md:w-full" />
            </UnstyledLink>
          </div>
          <div className="auth flex items-center gap-x-2 md:gap-x-8">
            <div>
              <Button onClick={handleOpenLogin} variant="text">
                Login
              </Button>
            </div>
            <div>
              <Button
                onClick={handleOpenRegister}
                className="hidden xs:flex font-normal"
                variant="primary"
                isArrow
                arrowClassName="animate-wiggle-side "
              >
                Sign up
              </Button>
              <Button
                onClick={handleOpenRegister}
                className="flex xs:hidden font-normal"
                variant="primary"
              >
                Sign up
              </Button>
            </div>
          </div>
        </nav>
      </Container>
    </header>
  );
};

export default Header;
